import React from "react";
import "./pageNotFound.css";

function NotFound() {
  return (
    <div className="coming-soon-container d-flex flex-column justify-content-center align-items-center text-center">
          <h1 className="coming-soon-title">Blogs Coming Soon</h1>
          <p className="coming-soon-subtext">Please contact us in case of an enquiry</p>
            <div className="container-button">
                <button
                  className="primary-button btn btn-primary btn-lg custom-shadow top-banner-button">
                  Enquire Now
                </button>
              </div>
        </div>
  );
}

export default NotFound;
